module.exports = __webpack_public_path__ + "0fd21dc46a623e6b9db1b0a96102452f.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/map.msgpack
 ** module id = 596
 ** module chunks = 0
 **/